<template>
    <div>
        <el-page-header @back="$emit('close')" content="工单明细"></el-page-header>
        <el-form :inline="true" @submit.native.prevent="reload">
            <el-form-item v-if="$root.couldExport">
                <el-button @click="form.tools[0].click">{{form.tools[0].label}}</el-button>
            </el-form-item>
            <form-item :config="form.configs[0]"></form-item>
            <form-item :config="form.configs[1]"></form-item>

            <el-button type="primary" native-type="submit">查询</el-button>
            <el-button @click="clear">重置</el-button>
        </el-form>
        <el-table :data="data">
            <el-table-column type="expand">
                <template #default="{row}">
                    <el-form label-position="left" class="table-expand">
                        <el-form-item label="部门名称">{{$root.getCustomerName(row.code)}}</el-form-item>
<!--                        <el-form-item label="短信通道">{{getChannelName(row.channel)}}</el-form-item>-->
                        <el-form-item label="短信内容">{{row.content}}</el-form-item>
                        <el-form-item label="成功条数">{{row.successCount}}</el-form-item>
                        <el-form-item label="失败条数">{{row.failCount}}</el-form-item>
                        <el-form-item label="状态描述">{{getErrMsg(row.errMsg)}}</el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="code" label="业务名称">
                <template #default="{row}">
                    {{$root.getBusinessName(row.code)}}
                </template>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号" width="110"></el-table-column>
            <el-table-column prop="totalCount" label="计费条数" width="80"></el-table-column>
            <el-table-column prop="submitTime" label="提交时间" width="150"></el-table-column>
            <el-table-column prop="sendTime" label="发送时间" width="150"></el-table-column>
        </el-table>
        <el-pagination
                @size-change="query"
                @prev-click="clickPrev"
                @next-click="clickNext"
                :page-sizes="[10, 20, 30, 50]"
                :page-size.sync="limit"
                :current-page.sync="page"
                :total="total"
                layout="total, sizes, slot, prev, next"
                prev-text="上一页"
                next-text="下一页">
            <el-button type="text" disabled>第{{page}}页</el-button>
        </el-pagination>
    </div>
</template>

<script>
    import FormItem from '@/components/FormItem'

    export default {
        components: {
            FormItem
        },
        props: ["jobId"],
        data() {
            return {
                form: {
                    configs: [
                        {label: "手机号", name: "mobile", type: "input", value: ""},
                        {
                            label: "状态", name: "status", type: "select", value: "", options: [
                                {label: "成功", value: "success"},
                                {label: "失败", value: "fail"},
                                {label: "未知", value: "unknown"},
                            ]
                        }
                    ],
                    tools: [
                        {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.post('/job/download', this.getQueryInfo()).then(response => {
                                  if (response.success) {
                                    this.$message(response['message']);
                                  } else {
                                    this.$message.error(response['message']);
                                  }
                                });
                              });
                            }
                        }
                    ]
                },
                channels: [],
                total: 0,
                data: [],
                page: 1,
                limit: 10,
                startRowKey: "",
                stopRowKey: "",
            }
        },
        mounted() {
            let options = [];
            this.$axios.post("/channel/list").then(results => {
                results.forEach(result => {
                    options.push({value: result.code, label: result.name});
                });
                this.channels = options;
                this.query();
            });
        },
        methods: {
            getChannelName(val) {
                let name = "";
                this.channels.forEach(option => {
                    if (val === option.value) {
                        name = option.label;
                        return false;
                    }
                });
                return name;
            },
            query() {
                this.$axios.post('/job/detail', this.getQueryInfo()).then(result => {
                    if (result['total'] !== undefined) {
                        this.total = result['total'];
                    }
                    this.data = result['rows'];
                })
            },
            reload() {
                this.startRowKey = "";
                this.stopRowKey = "";
                this.page = 1;

                this.query();
            },
            clear() {
                this.form.configs.forEach(config => {
                    config.value = null;
                });

                this.reload();
            },
            clickPrev() {
                if (this.data.length > 0) {
                    this.startRowKey = this.data[0]['id'];
                }
                this.stopRowKey = "";
                this.query();
            },
            clickNext() {
                this.startRowKey = "";
                if (this.data.length > 0) {
                    this.stopRowKey = this.data[this.data.length - 1]['id'];
                }
                this.query();
            },
            getQueryInfo() {
                let queryInfo = {
                    limit: this.limit,
                    rules: [{field: "jobId", value: this.jobId}]
                };

                this.form.configs.forEach((config) => {
                    let value = config['value'];
                    if (value) {
                        queryInfo['rules'].push({field: config['name'], value: value});
                    }
                });

                if (this.startRowKey) {
                    queryInfo['rules'].push({field: "startRowKey", value: this.startRowKey});
                }
                if (this.stopRowKey) {
                    queryInfo['rules'].push({field: "stopRowKey", value: this.stopRowKey});
                }

                return queryInfo;
            },
            getErrMsg(msg) {
                if (msg && msg.indexOf("余额不足") > 0) {
                    return "发送失败";
                }
                return msg;
            }
        }
    }
</script>

<style scoped>
    >>> .table-expand label {
        color: #99a9bf;
    }

    >>> .table-expand .el-form-item {
        margin-bottom: 0;
    }

    >>> .table-expand .el-form-item * {
        line-height: 30px;
    }
</style>